import naming from './naming';
import propTypes from './prop-types';
import quotes from './quotes';
import style from './style';

export default {
  naming,
  propTypes,
  quotes,
  style,
};
